export default __webpack_public_path__ + "static/media/3090.d1a41f1e.jpg";